/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { useVideosList } from '@api/hooks';

import SearchableEntitySelect from '../SearchableEntitySelect';

const VideoSelect = ({ placeholder = 'Type the name of video...', ...props }) => (
  <SearchableEntitySelect
    formatLabel={({ title }) => title}
    placeholder={placeholder}
    useList={useVideosList}
    {...props}
  />
);

export default VideoSelect;
